module.exports = __webpack_public_path__ + "static/icon_tools_2topt_sprite.13a88da3.png";